module.exports = __webpack_public_path__ + "static/boat1-2735b96f3091d52aa1581fa9ce86a151.jpg";